// extracted by mini-css-extract-plugin
export default {"tableRow":"LoanConfigurationsTable_tableRow__injVB"};